import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import { IconAlertCircle } from '@tabler/icons';

import {
  Container,
  InputElement,
  Header,
  WarningText,
  WarningIcon,
  Label,
} from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  required?: boolean;
  maxLength?: any;
  customStyle?: object;
}

export default function Input({
  label,
  name,
  required,
  customStyle,
  ...rest
}: InputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container id={name} style={customStyle}>
      <Header>
        <Label>
          {label} {required && <b style={{ color: 'var(--danger)' }}>*</b>}
        </Label>
        {error && <WarningText>{error}</WarningText>}
      </Header>

      <InputElement
        ref={inputRef}
        defaultValue={defaultValue}
        isErrored={!!error}
        name={name}
        onWheel={(e: any) => e.target.blur()}
        {...rest}
      />

      {error && (
        <WarningIcon>
          <IconAlertCircle size={20} color="#F65656" />
        </WarningIcon>
      )}
    </Container>
  );
}
